class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = this.querySelector('#cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.activeElement = null;
    this.cosmoshopEnsureBodyMount();

    if (!this.notification) return;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  cosmoshopEnsureBodyMount() {
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
    }
  }

  open() {
    if (!this.notification) return;

    this.cosmoshopEnsureBodyMount();
    this.classList.add('is-active');
    document.body.classList.add('cosmoshop-cart-notification-open');
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    if (!this.notification) return;

    this.notification.classList.remove('active');
    this.classList.remove('is-active');

    if (!document.querySelector('cart-notification.is-active')) {
      document.body.classList.remove('cosmoshop-cart-notification-open');
    }

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const html = parsedState.sections && parsedState.sections[section.id];
      const target = this.getSectionTarget(section.id);
      if (!html || !target) return;

      target.innerHTML = this.getSectionInnerHTML(html, section.selector);
    });

    this.header?.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionTarget(id) {
    if (id === 'cart-icon-bubble') return document.getElementById(id);
    return this.querySelector(`#${id}`);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const section = doc.querySelector(selector);
    return section ? section.innerHTML : html;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
